import { Component, OnInit } from '@angular/core';

import {
  APPLE_STORE_URL,
  PLAY_STORE_URL,
} from '../../constants/apps-store-url';

@Component({
  selector: 'app-redirect-to-app-stores',
  templateUrl: './redirect-to-app-stores.component.html',
  styleUrls: ['./redirect-to-app-stores.component.scss'],
})
export class RedirectToAppStoresComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
  };

  get url() {
    if (this.isMobile.iOS()) {
      return APPLE_STORE_URL;
    }
    return PLAY_STORE_URL;
  }

  goPlayStore() {
    window.location.href = PLAY_STORE_URL;
  }

  goAppleStore() {
    window.location.href = APPLE_STORE_URL;
  }

  chooseAppPage() {
    window.location.href = this.url;
  }
}
